
$(document).ready(function(){

    function setEqualSlideHeights(sliderEl) {
    const slides = sliderEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    slides.forEach(slide => {
      slide.style.height = 'auto';
    });

    let maxHeight = 0;
    slides.forEach(slide => {
      const height = slide.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    slides.forEach(slide => {
      slide.style.height = `${maxHeight}px`;
    });
}

const reviewCardSliders = document.querySelectorAll(".block-cards.swiper");
$(document).ready(function () {

  function setEqualSlideHeights(sliderEl) {
    const slides = sliderEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    requestAnimationFrame(() => {
      slides.forEach(slide => {
        slide.style.height = 'auto';
      });

      let maxHeight = 0;
      slides.forEach(slide => {
        const height = slide.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
      });

      // Optional: trigger reflow on iOS
      sliderEl.offsetHeight;
    });
  }

  const reviewCardSliders = document.querySelectorAll(".block-cards.swiper");

  reviewCardSliders.forEach((sliderEl) => {
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 2.5,
      autoHeight: false,
      simulateTouch: true,
      grabCursor: true,
      touchStartPreventDefault: false,
      passiveListeners: false,
      cssMode: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.5,
        }
      },
      on: {
        init: () => {
          setTimeout(() => setEqualSlideHeights(sliderEl), 50);
        },
        resize: () => {
          setTimeout(() => setEqualSlideHeights(sliderEl), 100);
        }
      }
    });

    window.addEventListener('load', () => {
      setTimeout(() => setEqualSlideHeights(sliderEl), 100);
    });

    window.addEventListener('resize', () => {
      setTimeout(() => setEqualSlideHeights(sliderEl), 150);
    });

    // Fix for iOS scroll issue
    let scrollDebounce;
    sliderEl.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        setEqualSlideHeights(sliderEl);
      }, 100);
    });

    // iOS orientation change
    window.addEventListener("orientationchange", () => {
      setTimeout(() => setEqualSlideHeights(sliderEl), 300);
    });
  });
});


    $(".marquee-track").slick({
      slidesToShow: 7,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0, 
      speed: 7000,      
      cssEase: 'linear',
      dots: false,
      arrows: false,
      variableWidth: true
    });
  });
  
  function equalizeSlickHeights() {
    let maxHeight = 0;
    $(".landing-review-slider-swiper .slick-slide").each(function () {
      const h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });
    $(".landing-review-slider-swiper .slick-slide").height(maxHeight);
  }
  
  $(window).on("load resize", equalizeSlickHeights);

// Video popup Close
const closeBtn = document.querySelector('.video-popup-close-icon');
const openBtn = document.querySelector('.block-landing__button.block-calm-video__button');
const popup = document.querySelector('.block-calm-video__popup-main');

if (closeBtn && popup) {
  closeBtn.addEventListener('click', function () {
    popup.style.display = 'none';
  });
}

if (openBtn && popup) {
  openBtn.addEventListener('click', function () {
    popup.style.display = 'block';
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".block__faq-accordion-faq-with-content-wrapper");

  // Expand only the first FAQ by default
  if (wrappers.length > 0) {
    wrappers[0].classList.add("faq-active");
  }

  wrappers.forEach((wrapper, index) => {
    const title = wrapper.querySelector(".block__faq-accordion-faq-title");

    title.addEventListener("click", () => {
      wrappers.forEach(w => w.classList.remove("faq-active")); // Collapse all
      wrapper.classList.add("faq-active"); // Expand only the clicked one
    });
  });
});



document.getElementById('subscriptions_select-otpions').addEventListener('change', function () {
  const selectedOption = this.options[this.selectedIndex];
  const selectedId = selectedOption.getAttribute('data-id');
  const selectedText = selectedOption.textContent;

  document.getElementById('selected-selling-plan').value = selectedId;
  const titleEl = document.querySelector('.block-subscription-product-title-inner');
  if (titleEl) {
    titleEl.textContent = selectedText;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const sublabelmain = document.querySelectorAll('.block-subscription-content');

  sublabelmain.forEach(container => {
    const deliveryRadios = container.querySelectorAll('input[name="delivery"]');

    // On page load
    deliveryRadios.forEach(radio => {
      const label = radio.closest('label');
      if (label) label.classList.toggle('is-active', radio.checked);
    });

    // On change
    deliveryRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        deliveryRadios.forEach(r => {
          const label = r.closest('label');
          if (label) label.classList.toggle('is-active', r.checked);
        });
      });
    });
  });
});

document.querySelectorAll('a.block-landing__button[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      e.preventDefault();
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});

  
